import React from 'react';

/**
 * Subtle invitation for guests to visit the couple's wedding website (their
 * custom site at /:friendlyURL). Kept understated so it complements the RSVP
 * rather than competing with it. Renders nothing without a friendlyURL.
 */
const WeddingWebsiteCallout = ({ friendlyURL }) => {
    if (!friendlyURL) {
        return null;
    }

    const websiteUrl = `${window.location.origin}/${friendlyURL}`;

    return (
        <>
            <div
                style={{
                    width: '100%',
                    maxWidth: '500px',
                    margin: '0 auto',
                    backgroundColor: '#eef2f8',
                    borderRadius: '14px',
                    padding: '30px 24px',
                    textAlign: 'center',
                }}
            >
                <p className="rsvp-subheader" style={{ margin: '0 0 16px 0' }}>
                    Our wedding website
                </p>
                <p
                    style={{
                        color: '#454C5C',
                        fontFamily: "'Albert Sans', sans-serif",
                        fontSize: '15px',
                        lineHeight: 1.6,
                        margin: '0 auto 24px',
                        maxWidth: '420px',
                    }}
                >
                    Everything for the big day lives here — the schedule, venue, travel and
                    all the little details. On the day itself, you'll be able to share your
                    photos and leave us a note.
                </p>
                <a
                    href={websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                >
                    <span
                        style={{
                            display: 'inline-block',
                            backgroundColor: '#4D8495',
                            color: 'white',
                            borderRadius: '50px',
                            padding: '14px 34px',
                            fontFamily: "'Albert Sans', sans-serif",
                            fontSize: '15px',
                            fontWeight: 600,
                        }}
                    >
                        Visit our website
                    </span>
                </a>
            </div>

            <div className="rsvp-line-break"></div>
        </>
    );
};

export default WeddingWebsiteCallout;
